export default __webpack_public_path__ + "static/media/matic.6598c0dc.svg";